/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h, H as Host } from './index-ef0fa435.js';

const appCss = "slot-fb[hidden],slot[hidden]{display:initial !important}lar-app{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:var(--lar-background-color, #000);color:var(--lar-text-color, #fff);font-family:var(--lar-font-family, inherit);display:block;position:relative !important;-ms-flex:1;flex:1;width:100%;height:100%;margin:0 !important;padding:0 !important;-webkit-overflow-scrolling:touch;will-change:scroll-position;-ms-scroll-chaining:none;overscroll-behavior:contain;overflow:auto}";

const LarvaApp = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, { class: { 'lar-app': true } }));
  }
};
LarvaApp.style = appCss;

export { LarvaApp as lar_app };

//# sourceMappingURL=lar-app.entry.js.map